import { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { SetupContext } from 'src/consumer/context/SetupContext'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { getFeatureItemBySlug } from 'src/consumer/services/featureServices'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { isTokenInvalidOrAbsent } from 'src/views/pages/login/ProtectedRoute'
import {
  InfoAndSingleActionComponentVarOne,
  RelatedAppFeaturesComponent,
} from '../ListingPageComponentsAndHelpers/ListingPageComponents'
import { LoadingSpinner } from '../Loaders'
import PrewallAndPaywall from '../PrewallAndPaywall/PrewallAndPaywall'
import PublicAppHeader from '../PublicAppHeader'
import { ClubbedAuthModal } from '../SignIn/ClubbedAuthComponents'

export default function TechniquePage() {
  const navigate = useNavigate()
  const { id, slug } = useParams()

  const { state } = useLocation()

  //
  // contexts:
  const { profileData } = useContext(ProfileContext)
  const { setupData } = useContext(SetupContext)

  //
  // data states:
  const [techniqueData, setTechniqueData] = useState()
  const [dataLoading, setDataLoading] = useState(false)
  const [prewallOpen, setPrewallOpen] = useState(false)
  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('login')

  useEffect(() => {
    pageSetup()
  }, [])

  async function pageSetup() {
    setDataLoading(true)

    let response
    if (slug) {
      response = await getFeatureItemBySlug('technique', slug, true)
    } else {
      response = await getFeatureItemBySlug('technique', id, false)
    }
    if (response?.status === 200 && response?.data && Object.keys(response?.data)?.length !== 0) {
      setTechniqueData(response?.data?.data?.technique)
      setDataLoading(false)
    } else {
      navigate('/404')
    }
  }

  const handleStartLandingPage = () => {
    if (isTokenInvalidOrAbsent(localStorage.getItem('token'))) {
      setShowClubbedAuthModal(true)
    } else {
      const timerToPass = {
        item: techniqueData,
      }
      if (slug) {
        navigate(`/timer/${slug}`, {
          state: timerToPass,
        })
      } else {
        navigate(`/timer/i/${id}`, {
          state: timerToPass,
        })
      }
    }
  }

  console.log(techniqueData)

  return (
    <>
      {techniqueData && (
        <SEOComponent
          title={`Take a ${techniqueData?.title} Test | AUMHUM`}
          description={`${techniqueData?.description}`}
          image={
            techniqueData && getImageLink(techniqueData?.coverIcon || techniqueData?.coverImage)
          }
        />
      )}
      {dataLoading ? (
        <LoadingSpinner bgColor="#F5F5F599" dark />
      ) : (
        <>
          <PublicAppHeader
            config={{ showLinks: false }}
            loginFunction={() => {
              setTypeOfClubbedAuthModal('login')
              setShowClubbedAuthModal(true)
            }}
            registerFunction={() => {
              setTypeOfClubbedAuthModal('signup')
              setShowClubbedAuthModal(true)
            }}
            propUserProfileData={profileData}
          />
          <ClubbedAuthModal
            open={showClubbedAuthModal}
            onClose={() => setShowClubbedAuthModal(false)}
            loginVariant={typeOfClubbedAuthModal === 'login'}
          />
          <PrewallAndPaywall
            id="journal_play"
            secureData={setupData}
            wallIsOpen={prewallOpen}
            toggleWall={() => {
              setPrewallOpen((prev) => !prev)
            }}
            onSuccessfulPaymentFunction={() => window.location.reload()}
          />
          <InfoAndSingleActionComponentVarOne
            headline={techniqueData?.title || ''}
            description={techniqueData?.description || ''}
            image={getImageLink(techniqueData?.coverIcon, techniqueData?.coverImage)}
            actionButtonText="Start Practice"
            clickFunction={techniqueData?.sadhana ? () => handleStartLandingPage() : null}
          />
          {techniqueData?.hasCourse && (
            <RelatedAppFeaturesComponent
              courseCategory={'meditation'}
              techniqueId={techniqueData?.id}
              featuresArrayInOrder={['course']}
            />
          )}
          {techniqueData?.hasCourse && (
            <RelatedAppFeaturesComponent
              courseCategory={'therepy'}
              techniqueId={techniqueData?.id}
              featuresArrayInOrder={['course']}
            />
          )}
        </>
      )}
    </>
  )
}
